import React, { useState } from 'react';
import Navbar from '../navbar/Navbar';
import { useNavigate } from 'react-router-dom';

const CreateJournal = () => {
  const [title, setTitle] = useState('');
  const [article, setArticle] = useState('');
  const [tags, setTags] = useState('');
  const [coverPicture, setCoverPicture] = useState(null);
  const user = localStorage.getItem('tokenUser');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('title', title);
    formData.append('article', article);
    formData.append('tags', tags);
    if (coverPicture) formData.append('coverPicture', coverPicture);

    try {
      const response = await fetch(`https://happyu.onrender.com/${user}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${user}` },
        body: formData
      });
      if (response.ok) {
        const newJournal = await response.json();
        setTitle('');
        setArticle('');
        setTags('');
        setCoverPicture(null);
        navigate(`/${user}/profile`);
      } else {
        console.error('Failed to create journal');
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };

  const handleFileChange = (e) => setCoverPicture(e.target.files[0]);

  return (
    <>
      <div className="min-h-screen w-full bg-gradient-to-r from-teal-50 via-indigo-50 to-white flex items-center pt-16 pb-20 px-2">
        <div className="max-w-lg w-full mx-auto bg-white/90 backdrop-blur rounded-2xl shadow-2xl border border-teal-100 px-8 py-10">
          <h2 className="text-3xl font-bold text-indigo-700 mb-6">Create Journal</h2>
          <form onSubmit={handleSubmit} className="space-y-7">
            <div>
              <label htmlFor="title" className="block text-sm font-semibold text-gray-700 mb-1">Title</label>
              <input
                id="title"
                type="text"
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow ring-1 ring-inset ring-teal-200 focus:ring-2 focus:ring-indigo-500"
                placeholder="Enter title"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                required
              />
            </div>
            <div>
              <label htmlFor="article" className="block text-sm font-semibold text-gray-700 mb-1">Article</label>
              <textarea
                id="article"
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow ring-1 ring-inset ring-teal-200 focus:ring-2 focus:ring-indigo-500 h-32"
                placeholder="Write your journal here..."
                value={article}
                onChange={(e) => setArticle(e.target.value)}
                required
              ></textarea>
            </div>
            <div>
              <label htmlFor="tags" className="block text-sm font-semibold text-gray-700 mb-1">Tags</label>
              <input
                id="tags"
                type="text"
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow ring-1 ring-inset ring-teal-200 focus:ring-2 focus:ring-indigo-500"
                placeholder="Enter tags (comma separated)"
                value={tags}
                onChange={(e) => setTags(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="coverPicture" className="block text-sm font-semibold text-gray-700 mb-2">Cover Picture</label>
              <input
                id="coverPicture"
                type="file"
                className="block w-full rounded-md border-0 py-2 px-3 text-gray-900 shadow ring-1 ring-inset ring-teal-200 focus:ring-2 focus:ring-indigo-500 bg-white"
                onChange={handleFileChange}
              />
            </div>
            <div className="flex items-center justify-end gap-4 pt-4">
              <button
                type="button"
                className="text-base font-semibold text-gray-700 px-5 py-2 bg-gray-100 rounded-md hover:bg-gray-200 transition"
                onClick={() => {
                  setTitle('');
                  setArticle('');
                  setTags('');
                  setCoverPicture(null);
                }}
              >
                Cancel
              </button>
              <button
                className="bg-indigo-600 hover:bg-teal-500 text-white font-bold px-6 py-2 rounded-md shadow transition focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-600"
                type="submit"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default CreateJournal;
